import { Route, Routes } from 'react-router'
import { observer, inject } from 'mobx-react'

import AuthCheck from './AuthCheck'
import { Onboarding, Main, Offboarding } from './views'
import UpgradeProduct from './views/offboarding/upgrade-product/UpgradeProduct'
import Cancellation from './views/offboarding/transactions/Cancellation'
import Discontinue from './views/profile/services/Discontinue'
import SuccessMessage from './views/login/SuccessMessage'
import ThemeWrapper from './themes/ThemeWrapper'
import AutoLogoutModal from './components/AutoLogoutModal'

function AuthenticatedApp() {
  return (
    <div>
      <Routes>
        <Route path='/discontinue' element={<Discontinue />} />
        <Route path='/cancel' element={<Cancellation />} />
        <Route path='/atmos/change-username/complete' element={<SuccessMessage />} />
        <Route path='/product-select' element={<UpgradeProduct />} />
        <Route path='/welcome/*' element={<Onboarding />} />
        <Route path='/implement/*' element={<Offboarding />} />
        <Route path='/implement-changes/*' element={<Offboarding />} />
        <Route path='/*' element={<Main />} />
      </Routes>
    </div>
  )
}

function GatewayApp(props) {
  const { isAuthenticated } = props.store.auth

  return (
    <div>
      <Routes>
        <Route
          path='/*'
          element={
            isAuthenticated ? (
              <ThemeWrapper>
                <AuthenticatedApp />
                <AutoLogoutModal />
              </ThemeWrapper>
            ) : (
              <AuthCheck />
            )
          }
        />
      </Routes>
    </div>
  )
}

export default inject('store')(observer(GatewayApp))
